// This function allow to reference async chunks
__webpack_require__.u = function(chunkId) {
	// return url for filenames based on template
	return "js/" + chunkId + "." + {"24":"fff2609a","71":"3d7623df","249":"1887dc2f","791":"5d344846","886":"79a4a68a"}[chunkId] + ".js";
};